import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/dhv_guava_turnover.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganGuavaTurnover() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Guava Turnover",
    content_category: "Vegan Menu",
    content_ids: ["vegan_guava_turnover"],
    content_type: "vegan_vietnamese_pastries",
    value: 2.50,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Guava Turnover | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="A crispy puff pastry filled with lush guava goodness. Flaky layers on the outside, tangy & fruity on the inside - ideal for indulging in a naturally sweet treat."
        />
        <meta
          property="og:title"
          content="Vegan Guava Turnover | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="A crispy puff pastry filled with lush guava goodness. Flaky layers on the outside, tangy & fruity on the inside - ideal for indulging in a naturally sweet treat."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN GUAVA TURNOVER"
          titleSubHead="$2.50 each"
          detailBody="A crispy puff pastry filled with lush guava goodness. Flaky layers on the outside, tangy & fruity on the inside - ideal for indulging in a naturally sweet treat."
          detailBodyBr="Contains: wheat, soy, almond"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganGuavaTurnover;